
// src/Views/Main Panel/MenuList/MenuListEndpoint.js
export const MenuListendpoint = {
  MenuList_list: `/api/v1/admin/food/get-all-food`,
  AddMenu_List: `/api/v1/admin/food/create-food`,
  ActiveInactive: `/api/v1/admin/food/toggle-availability/`,
  DeleteMenu: `/api/v1/admin/food/delete-food/`,
  UpdateFoodMenu: `/api/v1/admin/food/update-food/`,
  GetSingleMenu: `/api/v1/admin/food/get-food/`,
  BulkDelete: `/api/v1/admin/food/bulk-delete`,
  BulkUpdateStatus: `/api/v1/admin/food/bulk-update-availability`,
};